
import TableList from "@components/templates/tablelist";
import { HttpMiscInboundErpSku } from '@/service/misc';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            formData: {

            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpMiscInboundErpSku,
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_erpSku',
                show: true,
            },
                // {
                //     label: "描述",
                //     tag: 'vInput',
                //     key: 'CN_productsEntity.nameEn',
                //     show: true,
                // }
            ]
        },
        columns() {
            return [{
                title: "ERP SKU",
                key: 'erpSku'
            }, {
                title: this.$t('global.common.name', { defaultValue: "名称" }),
                key: 'name'
            },
            
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', { sku: row.erpSku})
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
